<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('tr')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/tr.png" alt="tr" />
        &nbsp;Türkçe
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('en')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" />
        &nbsp;English
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('ar')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/ar.png" alt="ar" />
        &nbsp;عربي
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  computed: {
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`);
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale == "en") return { flag: "en", lang: "English" };
      else if (locale == "ar") return { flag: "ar", lang: "عربي" };
    },
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      if (locale == "ar") this.$vs.rtl = true;
      else this.$vs.rtl = false;
    },
  },
};
</script>
